import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

// 豪车商品列表接口 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=27700084
export const get_luxury_car_list = createAsyncThunk(
  'LuxuryCarAuction/luxury_car_list',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<
        Pick<
          InitialStateType,
          'status' | 'count_down' | 'index' | 'luxury_car_list'
        >
      >
    >(
      '/live/activity/luxury_car_list',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 豪车商品点击购买按钮接口 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=27700333

export const luxury_car_buy = createAsyncThunk(
  'LuxuryCarAuction/luxury_car_buy',
  async (arg: {privilege_id: number; buy_cnt: number}, store: any) => {
    const resp = await http.post<
      HiyaRes<Pick<InitialStateType, 'status' | 'recharge_num' | 'err_msg'>>
    >('/live/activity/luxury_car_buy', {
      ...store.getState().env.deviceinfo,
      ...arg,
    })
    return resp.data.data
  }
)

interface luxury_car_type {
  privilege_id?: number
  user_remain_cnt: number
  user_limit: number
  sound_url: string
  show_url: string
  platform_remain_cnt: number
  platform_limit: number
  picture_url: string
  car_price: number
  car_name: string
  car_effect_days: number
  video_url: string
  // 打点用
  product_name: string
}

interface InitialStateType {
  // 主页面数据
  // 0：开卖中     1：未开始      2：已结束 3:不在活动地区
  status?: number
  count_down?: number
  index?: number
  luxury_car_list?: Array<luxury_car_type>
  recharge_num?: number
  err_msg?: string
}

const initialState: InitialStateType = {}

export const LuxuryCarAuctionSlice = createSlice({
  name: 'LuxuryCarAuction',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // 豪车商品列表接口成功
    builder.addCase(get_luxury_car_list.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
  },
})
export default LuxuryCarAuctionSlice.reducer
